import { WSElement, WSTableCell } from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { useBulkPayableBatchSummary } from "../../query/bulkPayable/queries";
import { useDefaultCurrency } from "../../../../shared/hooks/useDefaultCurrency";

export function BulkBatchImportTotal({ batchId }: { batchId: string }) {
  const qBulkPayableBatchItems = useBulkPayableBatchSummary(batchId);
  const defaultCurrency = useDefaultCurrency();

  if (qBulkPayableBatchItems.isLoading) {
    return <WSElement shimmer={true}>loading</WSElement>;
  }

  return (
    <WSTableCell
      text={formatMoney(
        qBulkPayableBatchItems.data?.netImportAmount!,
        defaultCurrency
      )}
    />
  );
}
